import { useState } from "react";
import { Link } from "react-router-dom";
import API, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Check } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-sm">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-[#475569] hover:text-[#0F172A] mb-6 transition-colors" data-testid="back-to-login">
          <ArrowLeft className="w-4 h-4" /> Volver a inicio de sesión
        </Link>
        <div className="text-center mb-8">
          <img src="https://customer-assets.emergentagent.com/job_promo-quote/artifacts/wgwlu5pd_WhatsApp%20Image%202026-03-27%20at%2018.43.52.jpeg" alt="PYM" className="h-10 w-auto mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-[#0F172A] tracking-tight" style={{ fontFamily: 'Chivo' }}>Recuperar Contraseña</h1>
          <p className="text-sm text-[#475569] mt-1">Te enviaremos instrucciones por email</p>
        </div>
        <div className="bg-white border border-[#E2E8F0] rounded-sm p-6">
          {sent ? (
            <div className="text-center py-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <Check className="w-6 h-6 text-green-600" />
              </div>
              <p className="text-sm text-[#0F172A] font-medium mb-1">Revisa tu email</p>
              <p className="text-xs text-[#475569]">Si el email existe en nuestro sistema, recibirás un enlace para restablecer tu contraseña.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
              <div>
                <Label className="text-sm font-medium text-[#0F172A]">Email de tu cuenta</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="tu@email.com" className="mt-1 border-[#CBD5E1] rounded-sm" data-testid="forgot-email-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[#0047AB] text-white font-bold rounded-sm py-2.5 hover:bg-[#003A8C] transition-colors" data-testid="forgot-submit-btn">
                {loading ? "Enviando..." : "Enviar Instrucciones"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
